const PageContainer = (props: any) => {
    return (
        <div>
            {props.children}
        </div>
    );
};

export default PageContainer;
